import script from "./footer-dark.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-dark.vue?vue&type=script&setup=true&lang=js"

import "./footer-dark.vue?vue&type=style&index=0&id=4b4b39a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4b39a6"]])

export default __exports__